import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAnalytics } from 'src/hooks/useAnalytics';
// import logo from 'src/assets/images/logo-anage-menu-white.svg';
import logo from 'src/assets/images/anage-select-branco.svg';
import whatsapp from 'src/assets/images/icons/whatsapp.svg';
import linkedin from 'src/assets/images/icons/linkedin-white.svg';
import facebook from 'src/assets/images/icons/facebook-white.svg';
import instagram from 'src/assets/images/icons/instagram-white.svg';
import youtube from 'src/assets/images/icons/youtube-white.svg';

import { getWhatsappLink } from 'src/utils/functions';
import whatsappWhite from 'src/assets/images/icons/whatsapp-white.svg';
import avatar from 'src/assets/images/broker.jpeg';

function Footer({ className }) {
  const generalInformation = useSelector((state) => state.interface.generalInformation);
  const brokerInformation = useSelector((state) => state.interface.brokerInformation);
  const { trackEvent } = useAnalytics();

  return (
    <div>
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="row">
              <div className="col-12 col-lg-3">
                {/* Logo and Social Media */}
                <div className="footer-brand">
                  <div className="footer-logo">
                    <img alt="Anagê Select" src={logo} className="img-logo" />
                  </div>

                  {/* WhatsApp Button */}
                  <div className="footer-whatsapp-button">
                    <a
                      href={getWhatsappLink('47999680934')}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-footer-whatsapp"
                      onClick={() => { trackEvent('Clique no botão', 'Whatsapp Footer Button', '47999680934'); }}
                    >
                      <img alt="WhatsApp" src={whatsappWhite} className="whatsapp-btn-icon" />
                      Fale pelo WhatsApp
                    </a>
                  </div>

                  <div className="footer-social d-sm-none d-md-flex">
                    <a href="https://www.linkedin.com/company/anage-imoveis-ltda/" target="_blank" rel="noopener noreferrer" className="social-link linkedin">
                      <img alt="LinkedIn" src={linkedin} className="social-icon" />
                    </a>
                    <a href="https://www.instagram.com/anageselect/" target="_blank" rel="noopener noreferrer" className="social-link instagram">
                      <img alt="Instagram" src={instagram} className="social-icon" />
                    </a>
                    <a href="https://www.facebook.com/anageselect/" target="_blank" rel="noopener noreferrer" className="social-link facebook">
                      <img alt="Facebook" src={facebook} className="social-icon" />
                    </a>
                    <a href="https://www.youtube.com/user/anagetv" target="_blank" rel="noopener noreferrer" className="social-link youtube">
                      <img alt="YouTube" src={youtube} className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-12 col-lg-9">
                <div className="row">
                  {/* Imóveis Column */}
                  <div className="col-12 col-md-4">
                    <div className="footer-column">
                      <h5 className="footer-title">Imóveis</h5>
                      <ul className="footer-links">
                        <li>
                          <RouterLink to="/comprar">Comprar Imóveis</RouterLink>
                        </li>
                        <li>
                          <a href="https://www.anageimoveis.com.br/anuncie-seu-imovel" target="_blank" rel="noopener noreferrer">
                            Vender Imóvel
                          </a>
                        </li>
                        <li>
                          <a href="https://www.anageimoveis.com.br/alugar" target="_blank" rel="noopener noreferrer">
                            Alugar
                          </a>
                        </li>
                        <li>
                          <RouterLink to="/lancamentos">Lançamentos</RouterLink>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Institucional Column */}
                  <div className="col-12 col-md-4">
                    <div className="footer-column">
                      <h5 className="footer-title">Institucional</h5>
                      <ul className="footer-links">
                        <li>
                          <RouterLink to="/institucional">Sobre nós</RouterLink>
                        </li>
                        <li>
                          <a href="https://anageimoveis.vagas.solides.com.br/" target="_blank" rel="noopener noreferrer">
                            Trabalhe Conosco
                          </a>
                        </li>
                        <li>
                          <a href="https://www.anageimoveis.com.br/joinville" target="_blank" rel="noopener noreferrer">
                            Joinville
                          </a>
                        </li>
                        <li>
                          <a href="https://www.anageimoveis.com.br/blog" target="_blank" rel="noopener noreferrer">
                            Blog
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Contact Column */}
                  <div className="col-12 col-md-4">
                    <div className="footer-column footer-contact-column">
                      <div className="footer-location">
                        <h5 className="footer-title">Onde estamos</h5>
                        <div className="footer-address">
                          <p>
                            Rua XV de Novembro, 1165
                            <br />
                            América - Joinville (SC)
                          </p>
                        </div>
                      </div>

                      <div class="footer-location">
                        <h5 class="footer-title">Horário de atendimento</h5>
                        <div class="footer-address">
                          <p>
                            08h - 18h de segunda à sexta; <br />
                            08h - 12h30 - sábado.
                          </p>
                        </div>
                      </div>

                      <div className="footer-contact">
                        <div className="contact-item">
                          <h6 className="footer-title">Telefone</h6>
                          <a href="tel:4730253002" className="contact-link">47 3025-3002</a>
                        </div>

                        <div className="contact-item">
                          <h6 className="footer-title">WhatsApp</h6>
                          <a
                            href={getWhatsappLink('47999680934')}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="contact-whatsapp"
                            onClick={() => { trackEvent('Clique no botão', 'Whatsapp Geral', '47999680934'); }}
                          >
                            <span>47 99968-0934</span>
                          </a>
                        </div>

                        <div className="contact-item">
                          <h6 className="footer-title">Encarregada/DPO</h6>
                          <span>Catia Michele Erhart</span>
                          <span>lgpd@anageimoveis.com.br</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 d-sm-block d-md-none">
                    <div className="footer-social">
                      <a href="https://www.linkedin.com/company/anage-imoveis-ltda/" target="_blank" rel="noopener noreferrer" className="social-link linkedin">
                        <img alt="LinkedIn" src={linkedin} className="social-icon" />
                      </a>
                      <a href="https://www.instagram.com/anageselect/" target="_blank" rel="noopener noreferrer" className="social-link instagram">
                        <img alt="Instagram" src={instagram} className="social-icon" />
                      </a>
                      <a href="https://www.facebook.com/anageselect/" target="_blank" rel="noopener noreferrer" className="social-link facebook">
                        <img alt="Facebook" src={facebook} className="social-icon" />
                      </a>
                      <a href="https://www.youtube.com/user/anagetv" target="_blank" rel="noopener noreferrer" className="social-link youtube">
                        <img alt="YouTube" src={youtube} className="social-icon" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Orange Divider */}
          <div className="footer-divider">
            <div className="container">
              <div className="divider-line" />
            </div>
          </div>

          {/* Copyright */}
          <div className="footer-bottom">
            <div className="container">
              <div className="copyright-content">
                <span className="copyright-text">
                  {new Date().getFullYear()}
                  {' © Anagê Imóveis. Todos os direitos reservados'}
                </span>
                <span className="separator">•</span>
                <RouterLink to="/politica-de-privacidade">Política de Privacidade</RouterLink>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {brokerInformation ? (
        <div className="broker-floating">
          <RouterLink to={`/corretores/${brokerInformation.broker.slug}`}>
            <div className="broker-header">
              <div className="broker-image" style={{ backgroundImage: `url(${brokerInformation.broker.photo})` }} />
              <div className="broker-name">{brokerInformation.broker.name}</div>
            </div>
          </RouterLink>
          {brokerInformation.broker.cellphone && (
          <a
            href={getWhatsappLink(brokerInformation.broker.cellphone)}
            target="_blank"
            className="btn btn-whats"
            onClick={() => { trackEvent('Clique no botão', 'Whatsapp Corretor', brokerInformation.broker.cellphone); }}
          >
            <img alt="" src={whatsapp} className="icon" />
            Fale pelo WhatsApp
          </a>
          )}
        </div>
      ) : (
        <>
          <a
            href={getWhatsappLink('47999680934')}
            target="_blank"
            className="btn btn-whats-floating"
            onClick={() => { trackEvent('Clique no botão', 'Whatsapp Geral', '47999680934'); }}
          >
            <img alt="" src={whatsappWhite} className="icon" />
          </a>
          {/* <div id="zoe-bot"></div> */}
        </>
      )}

    </div>
  );
}

Footer.propTypes = {
  className: PropTypes.string
};

export default Footer;
